/****************************************************
 * Module Name:  pendingReportComponent.js
 * Project:      Pansuriya Impex Sales & Manufacturing
 * Owner:        info@pansuriyaimpex.com
 *
 * Copyright (c) Pansuriya Impex
 * All rights reserved.
 ****************************************************/

import React, { useState } from "react";
import { DataGridPro, GridToolbar, GridToolbarColumnsButton, GridToolbarContainer, GridToolbarExport, GridToolbarFilterButton, GridToolbarQuickFilter } from "@mui/x-data-grid-pro";
import {
  Box,
  Button,
  FormControlLabel,
  FormGroup,
  Switch,
  Tooltip,
  Typography,
  Stack,
} from "@mui/material";
import RefreshOutlinedIcon from "@mui/icons-material/RefreshOutlined";
import { useEffect } from "react";
import Select from "react-select";
import CircularProgress from "@mui/material/CircularProgress";
import SearchOutlinedIcon from "@mui/icons-material/SearchOutlined";
import { ThemeProvider, createTheme } from "@mui/material";
import renderCellExpand from "./dataGridCellExpand";
import StoneDetailModal from "./stoneDetailModal";
import Utility from "../../utility/utility";
import LabTestProxy from "../../utility/proxy/manager/labTestProxy";
import LabProxy from "../../utility/proxy/manager/labProxy";
import Constants from "../../utility/constants";
import UserProxy from "../../utility/proxy/manager/userProxy";
import { LoadingButton } from "@mui/lab";
import CommonSnackbar from "./commonSnackBar";
import TotalStockComponent from "./totalStockComponent";
import PageTitle from "./pageTitle";

const PendingReport = ({ status, name }) => {
  const [lab, setLab] = useState([]);
  const [labOption, setLabOption] = useState([]);
  const [user, setUser] = useState([]);
  const [userOption, setUserOption] = useState([]);

  const [listData, setListData] = useState([]);

  const [reportReceivedListLoader, setReportReceivedListLoader] = useState(
    false
  );

  const [fetchData, setFetchData] = useState(false);

  const [mainData, setMainData] = useState([]);
  const [errorSnackbar, setErrorSnackbar] = useState(false);
  const [stoneId, setStoneId] = useState("");
  const [showStoneDetailModal, setShowStoneDetailModal] = useState(false);

  const [groupBy, setGroupBy] = useState(false);
  const [filterValues, setFilterValues] = useState({});


  useEffect(() => {
    PageTitle(name === "Stone" ? "REPORT_LABTEST_PENDINGSTONERECEIVE" : "REPORT_LABTEST_PENDINGREPORTRECEIVE");
    getAllLabData();
    getAllUserData();
  }, []);

  const getAllLabData = () => {
    LabProxy.GetAllLab((response) => {
      setAllLabData(response);
    });
  };

  const getAllUserData = () => {
    UserProxy.GetAllEmployeeMini("", (response) => {
      setAllUserData(response);
    });
  };

  const setAllLabData = (response) => {
    let optionsArray = [];
    response.map((data) => {
      let option = {
        value: data.id,
        label: data.name + " | " + data.location + " | " + data.country,
      };
      optionsArray.push(option);
      return true;
    });
    setLabOption(optionsArray);
    setLab(lab.length !== 0 && optionsArray.length > 0 ? optionsArray[0] : lab);

    setFetchData(true);
  };

  const setAllUserData = (response) => {
    let optionsArray = [];
    optionsArray.push({ value: "*", label: "-- ANY --" });
    response.map((data) => {
      let option = {
        value: data.id,
        label: data.username,
      };
      optionsArray.push(option);
      return true;
    });
    setUserOption(optionsArray);
    setUser(user.length !== 0 && optionsArray.length > 0 ? optionsArray[0] : user);

    setFetchData(true);
  };

  const fullOptionToValue = (selectedData, optionArr) => {
    if (selectedData.value === "*") {
      return [];
    }
    return Utility.GetValueArrayWithStarReplace(
      selectedData,
      Utility.GetValueArrayWithoutStar(optionArr)
    );
  };

  useEffect(() => {
    if (fetchData) {
      if (lab.value && user) {
        handleSearch(lab);
      }
    }
  }, [fetchData, lab, user]);

  const handleSearch = (llab) => {
    let statuss = status;
    let userIds = fullOptionToValue(user, userOption);
    setReportReceivedListLoader(true);
    LabTestProxy.GetAllTestingStonesInALabDetailReport(
      llab.value,
      statuss,
      userIds,
      (response) => {
        if (response) {
          const uniqueFilterValues = {
            teststatus: Utility.getDistinctOptions(response, "status"),
            stonelabdetailstatus: Utility.getDistinctOptions(response, "stonelabdetailstatus"),
            createdby: Utility.getDistinctOptions(response, "first_name"),
            created: Utility.getDistinctOptions(response, "username"),
          };
          setFilterValues(uniqueFilterValues);
          setListData(response);
          handleArray(response);
          setReportReceivedListLoader(false);
          setFetchData(false);
        } else {
          setReportReceivedListLoader(false);
          setErrorSnackbar(true);
        }
      }
    );
  };

  const handleStoneDetailModal = (params) => {
    setStoneId(params.value);
    setShowStoneDetailModal(true);
  };

  const handleClose = () => {
    setShowStoneDetailModal(false);
  };

  const handleArray = (lListData) => {
    let listIdTracker = 0;
    let newMainData = [];
    if (lListData.length > 0) {
      lListData
        .sort((a, b) => a.id - b.id)
        .map((list) => {
          if (listIdTracker === 0 || list.id !== listIdTracker) {
            listIdTracker = list.id;
            newMainData.push({
              id: list.id,
              createdat: list.createdat,
              createdby: list.username,
              createdbyname: list.first_name,
              labname: list.labname,
              labcity: list.location,
              labcountry: list.country,
              remark: list.remark,
            });
          }
          return true;
        });
    }
    setMainData(newMainData);
  };

  const columnName = [
    {
      field: "id",
      headerName: "TEST ID",
      headerAlign: "center",
      align: "center",
      type: "number",
      valueFormatter: (params) => params.value,
      width: 150,
    },
    {
      field: "createdat",
      headerName: "CREATED AT",
      headerAlign: "center",
      width: 170,
      align: "center",
      type: "dateTime",
      valueGetter: (params) => {
        if (params.value) {
          return new Date(params.value);
        }
        return null;
      },
      renderCell: (params) => {
        if (params.value) {
          return Utility.ConvertUtcToLocalTime(params.value);
        } else {
          return "";
        }
      }
    },
    {
      field: "username",
      headerName: "CREATED BY",
      headerAlign: "center",
      align: "center",
      type: "singleSelect",
      valueOptions: filterValues ? filterValues.created : [],
      filterOperators: Utility.combinedFilters(),
      renderCell: renderCellExpand,
      width: 170,
    },
    {
      field: "first_name",
      headerName: "CREATED BY",
      headerAlign: "center",
      width: 170,
      align: "center",
      type: "singleSelect",
      valueOptions: filterValues ? filterValues.createdby : [],
      filterOperators: Utility.combinedFilters(),
      renderCell: renderCellExpand,
    },
    {
      field: "status",
      headerName: "TEST STATUS",
      headerAlign: "center",
      align: "center",
      width: 150,
      type: "singleSelect",
      valueOptions: filterValues ? filterValues.teststatus : [],
      filterOperators: Utility.combinedFilters(),
      renderCell: renderCellExpand,
    },
    {
      field: "labname",
      headerName: "LAB",
      headerAlign: "center",
      width: 170,
      align: "center",
      renderCell: renderCellExpand,
    },
    {
      field: "location",
      headerName: "LAB CITY",
      headerAlign: "center",
      align: "center",
      width: 170,
      renderCell: renderCellExpand,
    },
    {
      field: "country",
      headerName: "LAB COUNTRY",
      headerAlign: "center",
      width: 170,
      align: "center",
      renderCell: renderCellExpand,
    },
    {
      field: "stoneid",
      headerName: "STONEID",
      width: 80,
      headerAlign: "center",
      align: "center",
      type: "number",
      valueFormatter: (params) => params.value,
      renderCell: (params) => Utility.NeedToShowStoneDetailModal() ?
        <Button
          sx={{ textDecorationLine: "underline" }}
          onClick={() => handleStoneDetailModal(params)}
        >
          {params.value}
        </Button>
        :
        <div>{params.value}</div>,
    },
    {
      field: "stonelabdetailstatus",
      headerName: "STONE STATUS",
      headerAlign: "center",
      width: 180,
      align: "center",
      type: "singleSelect",
      valueOptions: filterValues ? filterValues.stonelabdetailstatus : [],
      filterOperators: Utility.combinedFilters(),
      renderCell: renderCellExpand,
    },
    {
      field: "remark",
      headerName: "REMARK",
      headerAlign: "center",
      align: "center",
      width: 200,
      renderCell: renderCellExpand,
    },
    {
      field: "report",
      headerName: "REPORT",
      headerAlign: "center",
      align: "center",
      width: 180,
      renderCell: renderCellExpand,
    },
    {
      field: "resultdate",
      headerName: "RESULT DATE",
      headerAlign: "center",
      width: 150,
      align: "center",
      type: "date",
      valueGetter: (params) => {
        if (params.value) {
          return new Date(params.value);
        }
        return null;
      },
      renderCell: (params) => {
        if (params.value) {
          return Utility.ConvertUtcToLocalDate(params.value);
        } else {
          return "";
        }
      }
    },
  ];

  const materialDefaultColumns = [
    {
      headerName: "BATCH ID",
      field: "id",
      headerAlign: "center",
      align: "center",
      width: 100,
      type: "number",
      valueFormatter: (params) => params.value,
      renderCell: renderCellExpand,
    },
    {
      headerName: "CREATED AT",
      field: "createdat",
      headerAlign: "center",
      align: "center",
      width: 180,
      type: "dateTime",
      valueGetter: (params) => {
        if (params.value) {
          return new Date(params.value);
        }
        return null;
      },
      renderCell: (params) => Utility.ConvertUtcToLocalTime(params.value),
    },
    {
      headerName: "CREATED BY",
      field: "createdby",
      headerAlign: "center",
      align: "center",
      width: 150,
      type: "singleSelect",
      valueOptions: filterValues ? filterValues.created : [],
      filterOperators: Utility.combinedFilters(),
      renderCell: renderCellExpand,
    },
    {
      headerName: "CREATED BY NAME",
      field: "createdbyname",
      headerAlign: "center",
      align: "center",
      width: 150,
      type: "singleSelect",
      valueOptions: filterValues ? filterValues.createdby : [],
      filterOperators: Utility.combinedFilters(),
      renderCell: renderCellExpand,
    },
    {
      headerName: "LAB NAME",
      field: "labname",
      headerAlign: "center",
      align: "center",
      width: 150,
      type: "singleSelect",
      valueOptions: Constants.uniqueFilterValues.lab.sort((a, b) => a.seq - b.seq).map(option => option.value),
      filterOperators: Utility.combinedFilters(),
      renderCell: renderCellExpand,
    },

    {
      headerName: "LAB CITY",
      field: "labcity",
      headerAlign: "center",
      align: "center",
      width: 150,
      type: "singleSelect",
      valueOptions: Constants.uniqueFilterValues.location.sort((a, b) => a.seq - b.seq).map(option => option.value),
      filterOperators: Utility.combinedFilters(),
      renderCell: renderCellExpand,
    },
    {
      headerName: "LAB COUNTRY",
      field: "labcountry",
      headerAlign: "center",
      align: "center",
      width: 150,
      renderCell: renderCellExpand,
    },
    {
      headerName: "REMARK",
      field: "remark",
      headerAlign: "center",
      align: "center",
      width: 200,
      renderCell: renderCellExpand,
    },
  ];

  const CustomToolbar = () => {
    return (
      <GridToolbarContainer
        sx={{
          display: "flex",
          alignItems: "center",
          marginHorizontal: "5px",
          "&.MuiDataGrid-toolbarContainer": {
            padding: "0px 4px !important",
          },
        }}
      >
        <GridToolbarColumnsButton />
        <GridToolbarFilterButton />
        <GridToolbarExport />
        <Box sx={{ flexGrow: 1, display: "block" }} />
        {reportReceivedListLoader ? (
          <CircularProgress size="1rem" />
        ) : (
          <Tooltip title="Reload List">
            <RefreshOutlinedIcon
              onClick={() => handleSearch(lab)}
              color="primary"
              fontSize="medium"
              sx={{ cursor: "pointer" }}
            />
          </Tooltip>
        )}
        <GridToolbarQuickFilter debounceMs={500} />
      </GridToolbarContainer>
    )
  }

  const rows = listData;
  const columns = columnName;
  const defaultMaterialTheme = createTheme();

  const getDetailPanelHeight = React.useCallback(() => 'auto', []);

  const getDetailPanelContent = React.useCallback(
    (row, listData) => <DetailPanelContent row={row} listData={listData} />,
    [columns],
  );

  function DetailPanelContent({ row: rowProp, listData }) {
    let rows = listData.filter((data) => data.id === rowProp.id);
    return (
      <Stack
        sx={{ py: 2, height: '100%', boxSizing: 'border-box' }}
        direction="column"
      >
        <Box
          sx={{
            backgroundColor: '#fff',
            color: '#000',
            width: "100%",
            position: "relative",
            "& .MuiTablePagination-selectLabel": {
              marginTop: "15px",
            },
            "& .MuiTablePagination-displayedRows": {
              marginTop: "15px",
            },
            "& .css-1jbbcbn-MuiDataGrid-columnHeaderTitle": {
              fontWeight: Constants.defaultFontWeight,
            },
            "& .css-1knaqv7-MuiButtonBase-root-MuiButton-root": {
              color: "#1976d2",
              padding: "4px 5px",
              borderRadius: "4px",
            },
            "& .css-cc8tf1": {
              fontWeight: Constants.defaultFontWeight,
            },
            height: 'auto',
            marginLeft: '16px',
          }}
        >
          <DataGridPro
            disableRowSelectionOnClick={false}
            density="compact"
            columns={columns}
            rows={rows}
            getRowId={(row) => row.stoneid}
            sx={{
              '& .MuiDataGrid-columnHeader': {
                color: '#fff',
                backgroundColor: 'grey',
              },
              "&.MuiDataGrid-root--densityCompact .MuiDataGrid-cell": {
                py: "4px",
              },
              "&.MuiDataGrid-root--densityStandard .MuiDataGrid-cell": {
                py: "12px",
              },
              "&.MuiDataGrid-root--densityComfortable .MuiDataGrid-cell": {
                py: "18px",
              },
              fontSize: Constants.defaultTableFontSize, fontWeight: Constants.defaultFontWeight,
            }}
            slots={{ toolbar: GridToolbar }}
            slotProps={{
              toolbar: {
                showQuickFilter: true,
                quickFilterProps: { debounceMs: 500 },
              },
            }}
            initialState={{
              pagination: {
                paginationModel: Constants.pageSize,
              },
            }}
            pageSizeOptions={Constants.pageSizeOptions}
            pagination
          />
        </Box>
        <Box height={100}>
          <TotalStockComponent data={rows} />
        </Box>
      </Stack>
    );
  }

  return (
    <div>
      <CommonSnackbar
        show={errorSnackbar}
        message={Constants.APiFailErrorMessage}
        variant={"error"}
        autoHide={Constants.SnackBarCloseTimer}
        title={"Failed"}
        handleClose={() => setErrorSnackbar(false)}
      />
      {showStoneDetailModal ? (
        <StoneDetailModal
          show={showStoneDetailModal}
          stoneId={stoneId}
          handleClose={handleClose}
        />
      ) : null}
      <Box px={1}>
        <Box
          sx={{
            display: "flex",
            flexWrap: "wrap",
            width: "100%",
            gap: 2,
            mb: 3,
            alignItems: "center",
          }}
        >
          <Box
            sx={{
              display: "flex",
              flexDirection: { xs: "column", sm: "row" },
              minWidth: "270px",
              gap: 1,
            }}
          >
            <Typography alignSelf="center" mt={{ xs: 0, sm: 1 }}>
              Lab
            </Typography>
            <Box sx={{ flex: 1, minWidth: "160px", mt: { xs: 0, sm: 1 } }}>
              <Select
                menuPlacement="auto"
                blurInputOnSelect={false}
                menuPortalTarget={document.body}
                styles={Constants.Styles}
                getOptionLabel={(option) => option.label}
                getOptionValue={(option) => option.value}
                options={labOption}
                value={lab}
                onChange={(e) => setLab(e)}
              />
            </Box>
          </Box>

          <Box
            sx={{
              display: "flex",
              flexDirection: { xs: "column", sm: "row" },
              minWidth: "270px",
              gap: 1,
            }}
          >
            <Typography alignSelf="center" mt={{ xs: 0, sm: 1 }}>
              Users
            </Typography>
            <Box sx={{ flex: 1, minWidth: "160px", mt: { xs: 0, sm: 1 } }}>
              <Select
                menuPlacement="auto"
                blurInputOnSelect={false}
                menuPortalTarget={document.body}
                styles={Constants.Styles}
                isMulti
                closeMenuOnSelect={false}
                getOptionLabel={(option) => option.label}
                getOptionValue={(option) => option.value}
                options={userOption}
                value={user}
                onChange={(e) => setUser(e)}
              />
            </Box>
          </Box>

          <Box sx={{ minWidth: "120px", mt: 1 }}>
            <FormGroup>
              <FormControlLabel
                control={
                  <Switch
                    checked={groupBy}
                    onChange={() => setGroupBy(!groupBy)}
                  />
                }
                label="Group By"
              />
            </FormGroup>
          </Box>

          <Box sx={{ mt: 1 }}>
            <LoadingButton
              variant="contained"
              onClick={() => handleSearch(lab)}
              startIcon={<SearchOutlinedIcon size="large" />}
              loading={reportReceivedListLoader}
              loadingPosition="start"
              disabled={userOption.length === 0 || labOption.length === 0}
            >
              Search
            </LoadingButton>
          </Box>
        </Box>

        {!groupBy ? (
          <Box
            sx={{
              backgroundColor: '#fff',
              color: '#000',
              width: "100%",
              position: "relative",
              "& .MuiTablePagination-selectLabel": {
                marginTop: "15px",
              },
              "& .MuiTablePagination-displayedRows": {
                marginTop: "15px",
              },
              "& .css-1jbbcbn-MuiDataGrid-columnHeaderTitle": {
                fontWeight: Constants.defaultFontWeight,
              },
              "& .css-cc8tf1": {
                fontWeight: Constants.defaultFontWeight,
              },
              height: "80vh",
            }}
          >
            <DataGridPro
              disableRowSelectionOnClick={true}
              getRowHeight={() => "auto"}
              sx={{
                '& .MuiDataGrid-columnHeader': {
                  color: '#fff',
                  backgroundColor: 'grey',
                },
                "&.MuiDataGrid-root--densityCompact .MuiDataGrid-cell": {
                  py: "8px",
                },
                "&.MuiDataGrid-root--densityStandard .MuiDataGrid-cell": {
                  py: "15px",
                },
                "&.MuiDataGrid-root--densityComfortable .MuiDataGrid-cell": {
                  py: "22px",
                },
                fontSize: Constants.defaultTableFontSize, fontWeight: Constants.defaultFontWeight,
              }}
              density="compact"
              slots={{ toolbar: CustomToolbar }}
              rows={rows}
              columns={columns}
              getRowId={(row) => row.stoneid}
              loading={reportReceivedListLoader}
              initialState={{
                columns: {
                  columnVisibilityModel: {
                    // Hide columns id, the other columns will remain visible
                    labname: false,
                    location: false,
                    country: false,
                  },
                },
                pagination: {
                  paginationModel: Constants.pageSize,
                },
              }}
              pageSizeOptions={Constants.pageSizeOptions}
              pagination
              slotProps={{
                toolbar: {
                  showQuickFilter: true,
                  quickFilterProps: { debounceMs: 500 },
                },
              }}
            />
          </Box>
        ) : (
          <ThemeProvider theme={defaultMaterialTheme}>
            <Box
              sx={{
                backgroundColor: '#fff',
                color: '#000',
                width: "100%",
                position: "relative",
                "& .MuiTablePagination-selectLabel": {
                  marginTop: "15px",
                },
                "& .MuiTablePagination-displayedRows": {
                  marginTop: "15px",
                },
                "& .css-1jbbcbn-MuiDataGrid-columnHeaderTitle": {
                  fontWeight: Constants.defaultFontWeight,
                },
                "& .css-cc8tf1": {
                  fontWeight: Constants.defaultFontWeight,
                },
                "& .lavenderCell": {
                  color: "#080808",
                  backgroundColor: "#D8BFD8",
                },
                height: "75vh",
              }}
            >
              <DataGridPro
                disableRowSelectionOnClick={false}
                density="compact"
                columns={materialDefaultColumns}
                rows={mainData}
                getRowId={(row) => row.id}
                loading={reportReceivedListLoader}
                sx={{
                  '& .MuiDataGrid-columnHeader': {
                    color: '#fff',
                    backgroundColor: 'grey',
                  },
                  "&.MuiDataGrid-root--densityCompact .MuiDataGrid-cell": {
                    py: "4px",
                  },
                  "&.MuiDataGrid-root--densityStandard .MuiDataGrid-cell": {
                    py: "12px",
                  },
                  "&.MuiDataGrid-root--densityComfortable .MuiDataGrid-cell": {
                    py: "18px",
                  },
                  '& .MuiDataGrid-row': {
                    whiteSpace: 'nowrap',
                  },
                  fontSize: Constants.defaultTableFontSize, fontWeight: Constants.defaultFontWeight,
                }}
                slots={{ toolbar: CustomToolbar }}
                slotProps={{
                  toolbar: {
                    showQuickFilter: true,
                    quickFilterProps: { debounceMs: 500 },
                  },
                }}
                initialState={{
                  sorting: {
                    sortModel: [{ field: "id", sort: "desc" }],
                  },
                  pagination: {
                    paginationModel: Constants.pageSize,
                  },
                }}
                pageSizeOptions={Constants.pageSizeOptions}
                pagination
                getDetailPanelHeight={getDetailPanelHeight}
                getDetailPanelContent={({ row }) => getDetailPanelContent(row, listData)}
              />
            </Box>
          </ThemeProvider>
        )}
      </Box>
    </div>
  );
};

export default PendingReport;
